import React from 'react';
import './Header.css';
import logo from '../../assets/images/logo.png'; // Coloque sua logo na pasta assets/images

const Header = () => {
  return (
    <header className="header">
      <div className="header-container">
        <img src={logo} alt="Baterias Metropolitana" className="logo" />
        <div className="header-contact">
          <span>Ligue agora!</span>
          <a href="tel:(31) 3360-2809" className="header-phone-number">(31) 3360-2809</a>
        </div>
      </div>
    </header>
  );
}

export default Header;